import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

/**
 * 애드핏 광고
 * @param unit
 * @param width
 * @param height
 * @param style
 * @returns {Element}
 * @constructor
 */
const AdFitAd = ({ unit, width, height, style }) => {
  const adContainerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("src", "https://t1.kakaocdn.net/kas/static/ba.min.js");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("charset", "utf-8");
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <ins
      ref={adContainerRef}
      className="kakao_ad_area"
      style={{
        display: "none",
        width: "100%",
        maxWidth: "100%",
        maxHeight: "100%",
        boxSizing: "border-box",
        ...style,
      }}
      data-ad-unit={unit}
      data-ad-width={width}
      data-ad-height={height}
    ></ins>
  );
};

AdFitAd.propTypes = {
  unit: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
};

export default AdFitAd;
